import { render, staticRenderFns } from "./ProductExtraInfo.vue?vue&type=template&id=25a9e25d&scoped=true&"
import script from "./ProductExtraInfo.vue?vue&type=script&lang=ts&"
export * from "./ProductExtraInfo.vue?vue&type=script&lang=ts&"
import style0 from "./ProductExtraInfo.vue?vue&type=style&index=0&id=25a9e25d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a9e25d",
  null
  
)

export default component.exports